import { apiRequest } from './apiClient';

const withQuery = (path, query = {}) => {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    params.set(key, `${value}`);
  });

  const queryString = params.toString();
  return queryString ? `${path}?${queryString}` : path;
};

export const fetchAdminProductGroups = (options = {}) =>
  apiRequest(withQuery('/admin/master-data/product-groups', options), { auth: true });

export const createAdminProductGroup = (body) =>
  apiRequest('/admin/master-data/product-groups', {
    method: 'POST',
    auth: true,
    body,
  });

export const updateAdminProductGroup = (id, body) =>
  apiRequest(`/admin/master-data/product-groups/${id}`, {
    method: 'PATCH',
    auth: true,
    body,
  });

export const fetchAdminProductNames = (options = {}) =>
  apiRequest(withQuery('/admin/master-data/product-names', options), { auth: true });

export const createAdminProductName = (body) =>
  apiRequest('/admin/master-data/product-names', {
    method: 'POST',
    auth: true,
    body,
  });

export const updateAdminProductName = (id, body) =>
  apiRequest(`/admin/master-data/product-names/${id}`, {
    method: 'PATCH',
    auth: true,
    body,
  });

export const fetchAdminProductTypes = (options = {}) =>
  apiRequest(withQuery('/admin/master-data/product-types', options), { auth: true });

export const createAdminProductType = (body) =>
  apiRequest('/admin/master-data/product-types', {
    method: 'POST',
    auth: true,
    body,
  });

export const updateAdminProductType = (id, body) =>
  apiRequest(`/admin/master-data/product-types/${id}`, {
    method: 'PATCH',
    auth: true,
    body,
  });

export const fetchAdminCountries = (options = {}) =>
  apiRequest(withQuery('/admin/master-data/countries', options), { auth: true });

export const createAdminCountry = (body) =>
  apiRequest('/admin/master-data/countries', {
    method: 'POST',
    auth: true,
    body,
  });

export const updateAdminCountry = (id, body) =>
  apiRequest(`/admin/master-data/countries/${id}`, {
    method: 'PATCH',
    auth: true,
    body,
  });

export const fetchRoleCatalog = () => apiRequest('/master-data/catalog', { auth: true });

export const fetchRoleCountries = () => apiRequest('/master-data/countries', { auth: true });
